/**
 * Scroll to the next section after the Environment Hero containing the clicked button.
 * @param {HTMLElement | null | undefined} el - The button ("this") that triggered the action.
 */
function scrollToNextSection(el) {
    // If a trigger element is provided, scope to its closest hero; otherwise fall back to the first hero
    const currentSection = el?.closest ? el.closest('.environment-hero') : document.querySelector('.environment-hero');

    if (!currentSection) return;

    let nextSection = null;

    const currentShopifySection = currentSection.closest('.shopify-section');

    if (currentShopifySection) {
        // Find the next sibling that is a .shopify-section, skipping non-section siblings
        let nextShopifySection = currentShopifySection.nextElementSibling;
        while (nextShopifySection && !nextShopifySection.classList.contains('shopify-section')) {
            nextShopifySection = nextShopifySection.nextElementSibling;
        }

        if (nextShopifySection) {
            // Prefer a child that looks like a section; otherwise, scroll to the container itself
            nextSection = nextShopifySection.querySelector('section, .section, [class*="section"]') || nextShopifySection;
        }
    }

    if (!nextSection && currentShopifySection) {
        // Fallback: compute by index among all .shopify-section containers
        const allShopifySections = Array.from(document.querySelectorAll('.shopify-section'));
        const currentIndex = allShopifySections.indexOf(currentShopifySection);
        if (currentIndex !== -1 && currentIndex < allShopifySections.length - 1) {
            const nextContainer = allShopifySections[currentIndex + 1];
            if (nextContainer) {
                nextSection = nextContainer.querySelector('section, .section, [class*="section"]') || nextContainer;
            }
        }
    }

    if (nextSection) {
        // Account for sticky header heights; try common selectors with a sensible default
        const header =
            document.getElementById('header-group') ||
            document.getElementById('shopify-section-header') ||
            document.querySelector('[data-sticky-header], .sticky-header, header');
        const headerHeight = header ? header.offsetHeight : 98;

        const targetPosition = nextSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    } else {
        // Ultimate fallback: scroll one viewport
        window.scrollBy({
            top: window.innerHeight,
            behavior: 'smooth'
        });
    }
}

// Asegurar que la función esté disponible globalmente
window.scrollToNextSection = scrollToNextSection;
